(() => {
  function readVariants(dataElement) {
    try {
      return JSON.parse(dataElement?.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function getFormVariantInput(sectionId) {
    const form = document.getElementById(`product-form-${sectionId}`);
    return form ? form.querySelector('input[name="id"]') : null;
  }

  function setStockMessage(sectionId, variantId) {
    const display = document.getElementById(`VariantAvailability-${sectionId}`);
    const dataElement = document.getElementById(`VariantStockData-${sectionId}`);
    if (!display || !dataElement) return;

    const message = display.querySelector('[data-stock-message]');
    if (!message) return;

    if (display.dataset.storeCountry !== 'US') {
      message.textContent = 'Available to customers in the United States only';
      display.classList.add('is-country-restricted');
      display.classList.remove('is-sold-out');
      return;
    }
    display.classList.remove('is-country-restricted');

    const variants = readVariants(dataElement);
    const variant = variants.find((item) => String(item.id) === String(variantId));

    if (!variant) {
      message.textContent = 'Choose a color and size';
      display.classList.remove('is-sold-out');
      return;
    }

    if (!variant.available) {
      message.textContent = 'Out of stock';
      display.classList.add('is-sold-out');
      return;
    }

    display.classList.remove('is-sold-out');
    if (variant.inventoryManagement && Number.isFinite(Number(variant.inventoryQuantity))) {
      const quantity = Math.max(0, Number(variant.inventoryQuantity));
      message.textContent = quantity > 0 ? `${quantity} available` : 'In stock';
    } else {
      message.textContent = 'In stock';
    }
  }

  function syncSelectedVariant(sectionId, selector) {
    if (!selector) return;
    let selectedVariant = selector.currentVariant;
    if (!selectedVariant && typeof selector.getVariantData === 'function') {
      const selectedOptions = Array.from(selector.querySelectorAll('select, fieldset'), (element) => {
        if (element.tagName === 'SELECT') return element.value;
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      });
      selectedVariant = selector.getVariantData().find((variant) =>
        variant.options.every((option, index) => selectedOptions[index] === option)
      );
    }

    if (!selectedVariant) {
      setStockMessage(sectionId, null);
      return;
    }

    setStockMessage(sectionId, selectedVariant.id);
  }

  function bindStockDisplays() {
    document.querySelectorAll('[data-variant-stock-display]').forEach((display) => {
      const sectionId = display.dataset.sectionId;
      const selector = document.getElementById(`variant-selects-${sectionId}`);
      const form = document.getElementById(`product-form-${sectionId}`);
      const addButton = form ? form.querySelector('[name="add"]') : null;

      if (display.dataset.storeCountry !== 'US') {
        display.classList.add('is-country-restricted');
        if (addButton) {
          addButton.disabled = true;
          addButton.dataset.countryRestricted = 'true';
          const buttonText = addButton.querySelector('span');
          if (buttonText) buttonText.textContent = 'U.S. shipping only';
        }
      }

      if (!selector) {
        setStockMessage(sectionId, getFormVariantInput(sectionId)?.value);
        return;
      }

      if (selector.dataset.stockAvailabilityBound !== 'true') {
        selector.dataset.stockAvailabilityBound = 'true';
        selector.addEventListener('change', () => {
          window.setTimeout(() => syncSelectedVariant(sectionId, selector), 0);
        });
      }

      syncSelectedVariant(sectionId, selector);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindStockDisplays, { once: true });
  } else {
    bindStockDisplays();
  }
})();